<rotec-tile-v2
  [image]="tooling.pictureId | rotecImageV2 | async"
  [class.task-overdue]="tooling.kpi?.numberTasksOverdue"
  [borderForMain]="tooling.kpi?.numberTasksOverdue > 0"
  (tileClick)="openDetails()"
>
  <ng-container ngProjectAs="tile-v2-title" class="title">
    <div class="names">
      <span class="machine-name" [title]="tooling.name"
        ><span translate>Tooling</span>: {{ tooling.name }}</span
      >
    </div>
  </ng-container>
  <ng-container ngProjectAs="tile-v2-content">
    <div class="tile-block">
      <p class="block-title" translate>Task Overview</p>
      <p class="block-text" translate>Next Year (365 Days)</p>
    </div>
    <div class="tile-block">
      <p class="block-title tasks" translate>Tasks</p>
      <div class="block-content task">
        <p translate class="task__name">Planned</p>
        <div class="task__value">{{ tooling.kpi?.numberActiveTasks }}</div>
      </div>
      <div class="block-content task">
        <p translate class="task__name">High Priority</p>
        <div class="task__value">{{ tooling.kpi?.numberTasksHighPriority }}</div>
      </div>
      <div class="block-content task">
        <p translate class="task__name" [class.overdue]="!!tooling.kpi?.numberTasksOverdue">
          Overdue
        </p>
        <div class="task__value" [class.overdue]="!!tooling.kpi?.numberTasksOverdue">
          {{ tooling.kpi?.numberTasksOverdue }}
        </div>
      </div>
    </div>
    <div class="control-area">
      <button
        rotec-button-active
        icon="tasks"
        class="control-button"
        (click)="showTasks()"
      ></button>
    </div>
  </ng-container>
</rotec-tile-v2>
